import IsibuteDocumentTitle from "./IsibuteDocumentTitle";
import IsibuteDocumentSubtitle from "./IsibuteDocumentSubtitle";
import IsibuteDocumentSectionTitle from "./IsibuteDocumentSectionTitle";
import IsibuteDocumentImage from "./IsibuteDocumentImage";
import IsibuteDocumentParagraph from "./IsibuteDocumentParagraph";
import IsibuteDocumentEmphasis from "./IsibuteDocumentEmphasis";
import IsibuteDocumentCitationsSection from "./IsibuteDocumentCitationsSection";
import IsibuteDocumentCitation from "./IsibuteDocumentCitation";
import IsibuteDocumentUnorderedList from "./IsibuteDocumentUnorderedList";
import IsibuteDocumentUnorderedListItem from "./IsibuteDocumentUnorderedListItem";
import IsibuteDocumentResumeContactHeader from "./IsibuteDocumentResumeContactHeader";
import IsibuteDocumentResumeContactHeaderChild from "./IsibuteDocumentResumeContactHeaderChild";
import IsibuteDocumentResumeEntryDateRange from "./IsibuteDocumentResumeEntryDateRange";
import IsibuteDocumentResumeEntryTitle from "./IsibuteDocumentResumeEntryTitle";

const COMPONENT_REGISTRY = {
  'DocumentTitle': IsibuteDocumentTitle,
  'DocumentSubtitle': IsibuteDocumentSubtitle,
  'DocumentSectionTitle': IsibuteDocumentSectionTitle,
  'DocumentImage': IsibuteDocumentImage,
  'DocumentParagraph': IsibuteDocumentParagraph,
  'DocumentEmphasis': IsibuteDocumentEmphasis,
  'DocumentCitationsSection': IsibuteDocumentCitationsSection,
  'DocumentCitation': IsibuteDocumentCitation,
  'DocumentUnorderedList': IsibuteDocumentUnorderedList,
  'DocumentUnorderedListItem': IsibuteDocumentUnorderedListItem,
  'DocumentResumeContactHeader': IsibuteDocumentResumeContactHeader,
  'DocumentResumeName': IsibuteDocumentResumeContactHeaderChild,
  'DocumentResumeHeadline': IsibuteDocumentResumeContactHeaderChild,
  'DocumentResumeAddressLine': IsibuteDocumentResumeContactHeaderChild,
  'DocumentResumePhone': IsibuteDocumentResumeContactHeaderChild,
  'DocumentResumeEmail': IsibuteDocumentResumeContactHeaderChild,
  'DocumentResumeEntryDateRange': IsibuteDocumentResumeEntryDateRange,
  'DocumentResumeEntryTitle': IsibuteDocumentResumeEntryTitle,
};

export const documentComponentFromData = (data) => {
  return new COMPONENT_REGISTRY[data.documentComponentType](data);
};
